import { Deserializable } from '../deserializable';

export class Associate implements Deserializable {
  public AssociateSequenceNumber: number;
  public SocSequenceNumber?: number;
  public Type: string;
  public Name: string;
  public PhoneNumber: string;
  public AddressNo?: number;
  public AddressLine1: string;
  public AddressLine2: string;
  public AddressLine3: string;
  public County: string;
  public PostCode: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
